import React from 'react';
import { productName } from '../data/content';
type CoverSlotProps = {
  kicker: string;
  title: string;
  image?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  style?: React.CSSProperties;
};
const textSizes = {
  xs: {
    kicker: 'text-[0.4rem]',
    title: 'text-[0.45rem]',
    foot: 'hidden',
    pad: 'p-[8%]'
  },
  sm: {
    kicker: 'text-[0.42rem] sm:text-[0.55rem]',
    title: 'text-[0.55rem] sm:text-[0.78rem]',
    foot: 'text-[0.35rem] sm:text-[0.45rem]',
    pad: 'p-[10%]'
  },
  md: {
    kicker: 'text-[0.5rem] sm:text-[0.6rem]',
    title: 'text-[0.7rem] sm:text-[0.85rem]',
    foot: 'text-[0.4rem] sm:text-[0.5rem]',
    pad: 'p-[10%]'
  },
  lg: {
    kicker: 'text-[0.55rem] sm:text-[0.65rem]',
    title: 'text-[0.8rem] sm:text-base',
    foot: 'text-[0.45rem] sm:text-[0.55rem]',
    pad: 'p-[10%]'
  }
};

/**
 * Espacio para la portada real. Si `image` tiene URL se muestra el archivo original
 * sin alterar; si está vacío, se muestra un espacio preparado para reemplazarlo.
 */
export function CoverSlot({
  kicker,
  title,
  image,
  size = 'md',
  className = '',
  style
}: CoverSlotProps) {
  const shadow = 'shadow-[0_18px_30px_-14px_rgba(15,20,28,0.55)]';
  if (image) {
    return <img src={image} alt={`Portada de ${title}`} loading="lazy" className={`block h-auto w-full rounded-l-[2px] rounded-r-[5px] ring-1 ring-black/10 ${shadow} ${className}`} style={style} data-id="element-32" data-mp="1p4dzxk0hp6ay" />;
  }
  const t = textSizes[size];
  return <div role="img" aria-label={`Portada de ${title}`} className={`relative aspect-[1240/1754] w-full overflow-hidden rounded-[3px] bg-ink ${shadow} ${className}`} style={style} data-id="element-33" data-mp="2cyfcjk6jkh84">
      <span aria-hidden="true" className="absolute inset-y-0 left-0 w-[7%] bg-black/25" data-id="element-34" data-mp="2ms4gw9fbwpjt" />
      <div aria-hidden="true" className={`absolute inset-[6%] flex flex-col border border-ivory/15 ${t.pad}`} data-id="element-35" data-mp="2hrqizk7fyvzi">
        <span className={`font-sans font-semibold uppercase tracking-[0.14em] text-mustard ${t.kicker}`} data-id="element-36" data-mp="2von6bbocpvbn">
          {kicker}
        </span>
        <span className={`mt-auto font-display font-semibold uppercase leading-[1.15] text-ivory ${t.title}`} data-id="element-37" data-mp="2ysuo2s0tb0yd">
          {title}
        </span>
        <span className={`mt-[10%] border-t border-ivory/15 pt-[6%] font-sans uppercase tracking-[0.16em] text-ivory/55 ${t.foot}`} data-id="element-38" data-mp="33rp5pqn1mjgw">
          {productName}
        </span>
      </div>
    </div>;
}